module.exports = __webpack_public_path__ + "static/media/logo-3.57c9bb31.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-3.png
// module id = 88
// module chunks = 0